import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'consensi',
  titolo: 'Consensi e modulo firmato',
  gruppo: 'Le schede delle persone',
  permesso: 'consenso.registra',
  aCheServe: 'I consensi del modulo M03 si trascrivono nella scheda. **Sulle schede nuove, senza i consensi 1 e '
    + '2, gli interventi non si salvano.**',
  parti: [
    {
      titolo: 'Registrare i consensi',
      passi: [
        'Premi «Stampa la scheda», stampa il foglio e fallo firmare.',
        'Nella scheda apri la linguetta «Anagrafica» e scendi alla sezione «Consensi».',
        'Premi «Registra i consensi».',
        'Per ogni dichiarazione scegli «Esprimo» o «Non esprimo», come sul foglio. La quarta (immagine) può '
          + 'restare senza scelta.',
        'Spunta la presa visione dell’informativa. Compila «Luogo (Lì)», «Data della firma» e «Firmatario».',
        'Se hai già la scansione del foglio, sceglila in «Scansione del modulo firmato». Si può caricare anche dopo.',
        'Premi «Registra».',
      ],
      immagine: {
        file: 'consensi.webp', larghezza: 1200, altezza: 800,
        descrizione: 'La finestra Registrazione dei consensi con le dichiarazioni del modulo M03 e le scelte Esprimo e Non esprimo.',
      },
      nota: 'Un consenso non raccolto è diverso da un consenso negato: nessuna scelta è già fatta.',
    },
    {
      titolo: 'Quando firma un’altra persona',
      testo: [
        'In «Firmatario» puoi scegliere un genitore, il tutore, l’amministratore di sostegno o il responsabile '
          + 'della struttura di accoglienza. Scrivi «Nome e cognome di chi firma» e carica il «Documento sul '
          + 'potere di firma» (per esempio il decreto di tutela).',
        'Se il documento ora non c’è, registra lo stesso: i consensi valgono, ma la firma resta «da completare» '
          + 'e va completata entro 30 giorni. Arrivano gli avvisi, e la firma compare nella pagina «Da completare».',
      ],
    },
    {
      titolo: 'Completare una firma',
      passi: [
        'Nella sezione «Consensi», accanto alla firma da completare, premi «Completa».',
        'Carica il documento, oppure scegli «È già tra i documenti della scheda».',
        'Controlla il tipo e premi «Carica e collega» (o «Collega»).',
      ],
    },
    {
      titolo: 'Il modulo firmato',
      passi: [
        'Il modulo è un foglio solo: si carica una volta per tutte le dichiarazioni.',
        'Nella sezione «Consensi» premi «Carica il modulo firmato».',
        'Scegli «Carico il file adesso» oppure «È già tra i documenti della scheda», poi «Carica e collega».',
      ],
    },
    {
      titolo: 'La revoca',
      testo: [
        'Su una dichiarazione espressa premi «Registra la revoca», indica data e firmatario, poi conferma. Il '
          + 'consenso di prima resta nello storico. Sulle schede nuove, dopo la revoca del consenso 1 o 2, gli '
          + 'interventi non si registrano più.',
      ],
    },
  ],
  avvertenze: [
    {
      quando: 'I comandi «Salva» e «Salva come bozza» dell’intervento sono grigi.',
      cosaFare: 'Sulla scheda nuova mancano i consensi 1 e 2. Premi il collegamento «sezione Consensi della '
        + 'scheda», registrali e torna all’intervento.',
    },
    {
      quando: '«La firma resta da completare entro il …»',
      cosaFare: 'Hai registrato la firma di un terzo senza documento. Caricalo entro la data indicata con «Completa».',
    },
    {
      quando: 'La Direzione non trova «Registra i consensi».',
      cosaFare: 'La Direzione non registra i consensi: serve anche un incarico di Operatore interno sulla sede.',
    },
  ],
  vediAnche: ['scheda', 'anonimizzate', 'percorsi-interventi'],
  parole: ['privacy', 'informativa', 'firma', 'tutore', 'genitore', 'm03', 'revoca', 'scansione', 'gdpr'],
}

export default capitolo
